import Tabs from '@components/V4/Tabs/Tabs';
import { GetSessionDTO } from '@shared/clientTypes/DTOs/EnrollmentsDTO';
import SessionChatTab from './SessionChatTab/SessionChatTab';
import SessionFeedbackTab from './SessionFeedbackTab/SessionFeedbackTab';
import SessionMeetingsTab from './SessionMeetingsTab/SessionMeetingsTab';
import SessionNotesTab from './SessionNotesTab/SessionNotesTab';
import SessionScoringTab from './SessionScoringTab/SessionScoringTab';
import SessionTranscriptTab from './SessionTranscriptTab/SessionTranscriptTab';

export type SessionTab =
  | 'meetings'
  | 'feedback'
  | 'ai-scoring'
  | 'transcript'
  | 'new-transcript'
  | 'chat'
  | 'session-notes';

interface SessionTabsSectionProps {
  tab?: SessionTab;
  session?: GetSessionDTO;
}

const SessionTabsSection = (props: SessionTabsSectionProps) => {
  const { tab = 'meetings', session } = props;

  const tabs: { label: string; value: SessionTab }[] = [
    { label: 'Meetings', value: 'meetings' },
    { label: 'Feedback', value: 'feedback' },
    { label: 'AI Scoring', value: 'ai-scoring' },
    { label: 'Transcript', value: 'transcript' },
    { label: 'New Transcript', value: 'new-transcript' },
    { label: 'Chat', value: 'chat' },
    { label: 'Session Notes', value: 'session-notes' },
  ];

  const renderContent = (currentTab: SessionTab) => {
    switch (currentTab) {
      case 'meetings':
        return <SessionMeetingsTab name={session?.name ?? ''} meetings={session?.meetings ?? []} />;
      case 'feedback':
        return (
          <SessionFeedbackTab
            sessionId={session?.id}
            hasTranscript={
              !!session?.relevantMeeting?.newTranscript?.content?.length ||
              !!session?.relevantMeeting?.transcript?.length
            }
            mentorAIFeedback={session?.mentorAIFeedback}
            mentorFeedback={session?.mentorFeedback}
            studentFeedback={session?.studentFeedback}
            parentFeedback={session?.parentFeedback}
            mentorRecommendation={session?.mentorRecommendation}
          />
        );
      case 'ai-scoring':
        return <SessionScoringTab qualityScoring={session?.qualityScoring} />;
      case 'transcript':
        return (
          <SessionTranscriptTab
            transcript={session?.relevantMeeting?.transcript}
            meetingStartTime={session?.relevantMeeting?.startTime}
          />
        );
      case 'new-transcript':
        return (
          <SessionTranscriptTab
            transcript={session?.relevantMeeting?.newTranscript?.content ?? []}
            meetingStartTime={session?.relevantMeeting?.startTime}
          />
        );
      case 'chat':
        return (
          <SessionChatTab
            chat={session?.relevantMeeting?.chat}
            meetingStartTime={session?.relevantMeeting?.startTime}
          />
        );
      case 'session-notes':
        return (
          <SessionNotesTab
            mentorNotes={session?.relevantMeeting?.mentorNotes}
            studentsNotes={session?.relevantMeeting?.studentsNotes}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mt-6 h-full">
      <Tabs tabs={tabs} initialTab={tab} renderContent={renderContent} />
    </div>
  );
};

export default SessionTabsSection;
